import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';
const API_URL = import.meta.env.VITE_API_URL || `${API_BASE_URL}/api`;

const authHeaders = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('accessToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export interface DiscordGuild {
  id: string;
  name: string;
  icon?: string | null;
  owner?: boolean;
  permissions?: number;
}

export interface DiscordRole {
  id: string;
  name: string;
  color: number;
  position: number;
  permissions: number | string;
  managed: boolean;
  mentionable: boolean;
}

export interface SyncSummary {
  assigned: number;
  skipped: number;
  errors: number;
  total: number;
}

export const discordIntegrationService = {
  async getOAuthUrl() {
    const res = await axios.get(`${API_URL}/integrations/discord/oauth`, { headers: authHeaders() });
    return res.data as { url: string; state: string };
  },
  async finalizeCallback(code: string, state: string) {
    const res = await axios.get(`${API_URL}/integrations/discord/callback`, {
      params: { code, state },
      headers: authHeaders()
    });
    return res.data as { success: boolean; discordUser: any };
  },
  async listGuilds() {
    const res = await axios.get(`${API_URL}/integrations/discord/servers`, { headers: authHeaders() });
    return res.data as { guilds: DiscordGuild[] };
  },
  async listRoles(guildId: string) {
    const res = await axios.get(`${API_URL}/integrations/discord/servers/${guildId}/roles`, { headers: authHeaders() });
    return res.data as { roles: DiscordRole[] };
  },
  async saveTierRoleMapping(tierId: string, roleIds: string[]) {
    const res = await axios.post(`${API_URL}/integrations/discord/tiers/${tierId}/role-mapping`, { roleIds }, { headers: authHeaders() });
    return res.data as { success: boolean; tier: any };
  },
  async syncRoles() {
    const res = await axios.post(`${API_URL}/integrations/discord/sync-roles`, {}, { headers: authHeaders() });
    return res.data as { success: boolean; summary: SyncSummary };
  },
  async disconnect() {
    const res = await axios.post(`${API_URL}/integrations/discord/disconnect`, {}, { headers: authHeaders() });
    return res.data as { success: boolean };
  }
};

export default discordIntegrationService;